<template>
    <div v-show="false"></div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        event_name: {
            type: String,
            required: true
        },
        evento_id: {
            type: String,
            required: false
        },
        nombre: {
            type: String,
            required: false
        },
        apellidos: {
            type: String,
            required: false
        },
        email: {
            type: String,
            required: false
        },
        telefono: {
            type: [Number, String],
            required: false
        },
        user_order: {
            type: String,
            required: false
        },
        quantity: {
            type: Number,
            required: false
        },
        total: {
            type: Number,
            required: false
        },
        url_evento: {
            type: String,
            required: false
        },
        cp: {
            type: String,
            required: false
        },
        user_id: {
            type: Number,
            required: false
        },
        evento_name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            ip: null
        }
    },
    created() {
        this.getIp();
    },
    methods: {
        sendPetition() {
            const pixel = require('facebook-nodejs-business-sdk');
            const Content = pixel.Content;
            const CustomData = pixel.CustomData;
            const DeliveryCategory = pixel.DeliveryCategory;
            const EventRequest = pixel.EventRequest;
            const UserData = pixel.UserData;
            const ServerEvent = pixel.ServerEvent;

            const access_token = process.env.VUE_APP_ACCESS_TOKEN;
            const pixel_id = process.env.VUE_APP_PIXEL_ID;
            const api = pixel.FacebookAdsApi.init(pixel_id, {'external_ID': this.evento_id});
            let current_timestamp = moment().format('X');

            const userData = (new UserData())
                .setEmails([this.email])
                .setPhones([this.telefono])
                .setClientIpAddress(this.ip)
                .setClientUserAgent(window.navigator.userAgent)
                .setFbp(this.$cookies.get('_fbp'))
                .setFbc(this.$cookies.get('_fbc'))
                .setLastName(this.apellidos)
                .setFirstName(this.nombre)
                .setCity('es')
                .setZip(this.cp)
                .setState('es')
                .setCountry('es')
                .setExternalId(this.evento_id)
                .setSubscriptionId(this.user_id);

            const content = (new Content())
                .setId(this.user_order)
                .setQuantity(this.quantity)
                .setDeliveryCategory(DeliveryCategory.IN_STORE);

            const customData = (new CustomData())
                .setContents([content])
                .setCurrency('eur')
                .setValue(this.total);

            const serverEvent = (new ServerEvent())
                .setEventName(this.event_name)
                .setEventTime(current_timestamp)
                .setUserData(userData)
                .setCustomData(customData)
                .setEventSourceUrl(this.url_evento)
                .setActionSource('website')
                .setEventId(this.user_order);

            const eventsData = [serverEvent];
            const eventRequest = (new EventRequest(access_token, pixel_id))
                .setEvents(eventsData);

            eventRequest.execute();
        },
        getIp() {
            axios.get('https://api.ipify.org/?format=json').then(res => {
                this.ip = res.data.ip;
                this.sendPetition();
            });
        }
    }
}
</script>
